import { render, staticRenderFns } from "./TopTenView.vue?vue&type=template&id=aa76444c&scoped=true&"
import script from "./TopTenView.vue?vue&type=script&lang=js&"
export * from "./TopTenView.vue?vue&type=script&lang=js&"
import style0 from "./TopTenView.vue?vue&type=style&index=0&id=aa76444c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa76444c",
  null
  
)

export default component.exports